/* =========================================================
   CONFIG — paste your Google Sheet ID here
   ========================================================= */
const SHEET_ID = '1pAnicSNXZlpOS6uWRzENZEKbThmpFJwp9txOG7I0ADg';
const SUBMISSIONS_TAB = 'Submissions';
const SESSIONS_TAB = 'Sessions';

/* =========================================================
   LOGO
   ========================================================= */
// Logo URL is injected via window.LOGO_URL from the Liquid template
document.getElementById('brandLogo').src = window.LOGO_URL || '';

/* =========================================================
   QUADRANT INFO (for descriptor coloring)
   ========================================================= */
const QUAD_MAP = {
  // Look up by descriptor name — derived from the spectrum scorer dataset.
  // Used for coloring descriptor chips since the Sheet stores descriptors as a string.
  // (Sub-set list of common ones; unknown descriptors fall back to gray.)
};
const PURPLE_NOTES = ['Blackberry','Blueberry','Black Currant','Mulberry','Dark Grape','Dark Plum','Fig','Date','Prune','Raisin','Red Wine','Port','Rum','Cacao Nib','Dark Chocolate','Licorice','Star Anise','Clove','Cinnamon','Pepper'];
const WHITE_NOTES  = ['Black Tea','Bergamot','Lavender','Elderflower','Violet','Jasmine','Orchid','Magnolia','Lemongrass','Coffee Blossom','White Tea','Champagne','White Wine','White Grape','White Peach','White Sugar','Cane Sugar','Honeydew','Pear','Lemonade'];
const YELLOW_NOTES = ['Green Apple','Lime','Kiwi','Starfruit','Citrus Blossom','Chamomile','Green Tea','Jackfruit','Pineapple','Passion Fruit','Mango','Apricot','Nectarine','Yellow Peach','Yellow Plum','Honey','Sultana','Caramel','Toffee','Malt'];
const RED_NOTES    = ['Brown Sugar','Molasses','Milk Chocolate','Grapefruit','Mandarin','Orange','Blood Orange','Tangerine','Papaya','Guava','Pomegranate','Cherry','Red Apple','Red Grape','Red Plum','Cranberry','Strawberry','Raspberry','Watermelon','Rose','Hibiscus'];
PURPLE_NOTES.forEach(n => QUAD_MAP[n] = 'purple');
WHITE_NOTES.forEach(n => QUAD_MAP[n] = 'white');
YELLOW_NOTES.forEach(n => QUAD_MAP[n] = 'yellow');
RED_NOTES.forEach(n => QUAD_MAP[n] = 'red');

/* =========================================================
   STATE
   ========================================================= */
const state = {
  rawSubmissions: [],   // raw from Sheet, parsed
  rawSessions: [],
  filtered: [],         // submissions matching current filters
  filteredSessions: [],
  mode: 'overview',
  charts: {},
  filters: {
    dateFrom: '', dateTo: '',
    origin: '', brew: '', use: '', cupper: '',
    scoreMin: '', scoreMax: '',
    descriptor: ''
  }
};

/* =========================================================
   HELPERS
   ========================================================= */
const $ = (id) => document.getElementById(id);
const escapeHtml = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
function formatDate(iso) {
  if (!iso) return '—';
  try { return new Date(iso).toLocaleDateString('en-GB', { day:'2-digit', month:'short', year:'numeric' }).toUpperCase(); }
  catch { return iso; }
}
function shortDate(iso) {
  if (!iso) return '—';
  try { return new Date(iso).toLocaleDateString('en-GB', { day:'2-digit', month:'short', year:'2-digit' }); }
  catch { return iso; }
}
function gradeFor(score) {
  if (score >= 90) return { label: 'Outstanding', specialty: true };
  if (score >= 85) return { label: 'Excellent', specialty: true };
  if (score >= 80) return { label: 'Specialty', specialty: true };
  if (score >= 70) return { label: 'Below Specialty', specialty: false };
  if (score >= 60) return { label: 'Commercial', specialty: false };
  return { label: 'Off-grade', specialty: false };
}

function setStatus(text, kind) {
  $('statusText').textContent = text;
  $('statusPill').classList.remove('connected', 'error');
  if (kind) $('statusPill').classList.add(kind);
}
function setFootStatus(text) { $('footStatus').textContent = text; }

function configValid() {
  return SHEET_ID && !SHEET_ID.includes('__PASTE_');
}

/* =========================================================
   GVIZ LOAD
   ========================================================= */
async function gvizFetch(tab) {
  const url = `https://docs.google.com/spreadsheets/d/${SHEET_ID}/gviz/tq?tqx=out:json&sheet=${encodeURIComponent(tab)}`;
  const res = await fetch(url);
  if (!res.ok) throw new Error('Sheet fetch failed: ' + res.status);
  const text = await res.text();
  // gviz wraps JSON in a JS callback; strip it
  const match = text.match(/google\.visualization\.Query\.setResponse\((.*)\);?\s*$/s);
  if (!match) throw new Error('Unexpected gviz response format. Check Sheet sharing is set to "Anyone with the link".');
  const json = JSON.parse(match[1]);
  if (json.status === 'error') {
    throw new Error('Sheet error: ' + (json.errors && json.errors[0] && json.errors[0].detailed_message || 'unknown'));
  }
  return json.table;
}

function rowsFromTable(table) {
  if (!table || !table.cols) return [];
  const headers = table.cols.map(c => c.label || c.id);
  return (table.rows || []).map(r => {
    const obj = {};
    headers.forEach((h, i) => {
      const cell = r.c && r.c[i];
      let v = cell ? cell.v : null;
      // gviz dates come as Date objects already, or strings
      if (v && typeof v === 'object' && v.toISOString) v = v.toISOString();
      // Also, gviz date columns return string like 'Date(2026,4,16)' sometimes
      if (typeof v === 'string' && v.startsWith('Date(')) {
        const m = v.match(/Date\((\d+),(\d+),(\d+)(?:,(\d+),(\d+),(\d+))?\)/);
        if (m) {
          const d = new Date(Date.UTC(+m[1], +m[2], +m[3], +(m[4]||0), +(m[5]||0), +(m[6]||0)));
          v = d.toISOString();
        }
      }
      obj[h] = v;
    });
    return obj;
  });
}

async function loadAllData() {
  if (!configValid()) {
    $('configNotice').classList.add('show');
    setStatus('Setup required', 'error');
    return;
  }
  try {
    setStatus('Loading…');
    setFootStatus('Fetching Sheet…');
    const [subTable, sessTable] = await Promise.all([
      gvizFetch(SUBMISSIONS_TAB),
      gvizFetch(SESSIONS_TAB).catch(() => null)   // Sessions tab optional
    ]);
    const submissions = rowsFromTable(subTable);
    const sessions = sessTable ? rowsFromTable(sessTable) : [];

    // Normalize numbers and parse descriptors
    state.rawSubmissions = submissions.map(s => normalizeSubmission(s));
    state.rawSessions = sessions.map(s => normalizeSession(s));

    $('configNotice').classList.remove('show');
    setStatus('Connected', 'connected');
    setFootStatus('Loaded ' + state.rawSubmissions.length + ' submissions');

    populateFilterDropdowns();
    applyFilters();
  } catch (e) {
    console.error(e);
    setStatus('Load failed', 'error');
    setFootStatus('Error: ' + e.message);
    $('configNotice').innerHTML = `
      <strong>Could not load Sheet</strong><br>
      ${escapeHtml(e.message)}<br><br>
      Make sure the Sheet ID is correct and the Sheet is set to <strong>"Anyone with the link can view"</strong>.
    `;
    $('configNotice').classList.add('show');
  }
}

function normalizeSubmission(s) {
  // Column names from our Apps Script. Some Sheets clients return cell labels;
  // others return cell IDs (A, B, C…). Be defensive.
  return {
    sessionId: s['Session ID'] || s['A'] || '',
    sessionName: s['Session Name'] || s['B'] || '',
    sessionDate: s['Session Date'] || s['C'] || '',
    host: s['Host'] || s['D'] || '',
    location: s['Location'] || s['E'] || '',
    closedAt: s['Closed At'] || s['F'] || '',
    sampleNum: s['Sample #'] || s['G'] || '',
    sampleName: s['Sample Name'] || s['H'] || '',
    origin: s['Origin'] || s['I'] || '',
    brew: s['Brew Method'] || s['J'] || '',
    use: s['Intended Use'] || s['K'] || '',
    cupperName: s['Cupper Name'] || s['L'] || '',
    impression: parseFloat(s['Overall Impression'] || s['M'] || 0),
    score: parseFloat(s['Final Score'] || s['N'] || 0),
    scoreType: s['Score Type'] || s['O'] || '',
    grade: s['Grade'] || s['P'] || '',
    descriptorsRaw: s['Descriptors'] || s['Q'] || '',
    cupperNotes: s['Cupper Notes'] || s['R'] || '',
    submittedAt: s['Submitted At'] || s['S'] || ''
  };
}
function normalizeSession(s) {
  return {
    sessionId: s['Session ID'] || s['A'] || '',
    sessionName: s['Session Name'] || s['B'] || '',
    date: s['Date'] || s['C'] || '',
    host: s['Host'] || s['D'] || '',
    location: s['Location'] || s['E'] || '',
    createdAt: s['Created At'] || s['F'] || '',
    closedAt: s['Closed At'] || s['G'] || '',
    coffees: parseInt(s['Coffees'] || s['H'] || 0),
    cuppers: parseInt(s['Cuppers'] || s['I'] || 0),
    submissions: parseInt(s['Submissions'] || s['J'] || 0),
    notes: s['Notes'] || s['K'] || ''
  };
}

function parseDescriptors(raw) {
  // Format from host: "Blackberry (i:4) | Mango (i:3) | Honey (i:5)"
  if (!raw) return [];
  return raw.split('|').map(s => s.trim()).filter(Boolean).map(s => {
    const m = s.match(/^(.+?)\s*\(i:(\d+)\)/);
    if (m) return { name: m[1].trim(), intensity: parseInt(m[2]) };
    return { name: s, intensity: 3 };
  });
}

/* =========================================================
   FILTERS
   ========================================================= */
function populateFilterDropdowns() {
  const origins = new Set(), brews = new Set(), uses = new Set(), cuppers = new Set();
  state.rawSubmissions.forEach(s => {
    if (s.origin) origins.add(s.origin);
    if (s.brew) brews.add(s.brew);
    if (s.use) uses.add(s.use);
    if (s.cupperName) cuppers.add(s.cupperName);
  });
  function fill(selId, values) {
    const sel = $(selId);
    const current = sel.value;
    sel.innerHTML = '<option value="">All</option>';
    [...values].sort().forEach(v => {
      const opt = document.createElement('option');
      opt.value = v;
      opt.textContent = v;
      sel.appendChild(opt);
    });
    sel.value = current;
  }
  fill('fOrigin', origins);
  fill('fBrew', brews);
  fill('fUse', uses);
  fill('fCupper', cuppers);
}

function readFilters() {
  state.filters = {
    dateFrom: $('fDateFrom').value,
    dateTo: $('fDateTo').value,
    origin: $('fOrigin').value,
    brew: $('fBrew').value,
    use: $('fUse').value,
    cupper: $('fCupper').value,
    scoreMin: $('fScoreMin').value,
    scoreMax: $('fScoreMax').value,
    descriptor: $('fDescriptor').value.trim().toLowerCase()
  };
}

function matchesFilters(s) {
  const f = state.filters;
  if (f.origin && s.origin !== f.origin) return false;
  if (f.brew && s.brew !== f.brew) return false;
  if (f.use && s.use !== f.use) return false;
  if (f.cupper && s.cupperName !== f.cupper) return false;
  if (f.scoreMin !== '' && s.score < parseFloat(f.scoreMin)) return false;
  if (f.scoreMax !== '' && s.score > parseFloat(f.scoreMax)) return false;
  if (f.dateFrom || f.dateTo) {
    const dateStr = s.sessionDate || s.submittedAt;
    if (dateStr) {
      const d = new Date(dateStr);
      if (f.dateFrom && d < new Date(f.dateFrom)) return false;
      if (f.dateTo) {
        const end = new Date(f.dateTo);
        end.setHours(23,59,59,999);
        if (d > end) return false;
      }
    }
  }
  if (f.descriptor) {
    if (!s.descriptorsRaw.toLowerCase().includes(f.descriptor)) return false;
  }
  return true;
}

function applyFilters() {
  readFilters();
  state.filtered = state.rawSubmissions.filter(matchesFilters);

  // Derive filtered sessions from filtered submissions
  const sessionIds = new Set(state.filtered.map(s => s.sessionId));
  state.filteredSessions = state.rawSessions.filter(s => sessionIds.has(s.sessionId));
  if (state.filteredSessions.length === 0 && state.rawSessions.length === 0) {
    // No Sessions tab — synthesize from submissions
    const map = {};
    state.filtered.forEach(s => {
      if (!map[s.sessionId]) {
        map[s.sessionId] = {
          sessionId: s.sessionId,
          sessionName: s.sessionName,
          date: s.sessionDate,
          host: s.host,
          location: s.location,
          closedAt: s.closedAt,
          coffees: new Set(),
          cuppers: new Set(),
          submissions: 0,
          scoresSum: 0
        };
      }
      map[s.sessionId].coffees.add(s.sampleName);
      map[s.sessionId].cuppers.add(s.cupperName);
      map[s.sessionId].submissions++;
      map[s.sessionId].scoresSum += s.score;
    });
    state.filteredSessions = Object.values(map).map(m => ({
      ...m,
      coffees: m.coffees.size,
      cuppers: m.cuppers.size,
      avgScore: m.submissions > 0 ? m.scoresSum / m.submissions : 0
    }));
  } else {
    // attach avg score per session from filtered submissions
    const scoreMap = {};
    state.filtered.forEach(s => {
      if (!scoreMap[s.sessionId]) scoreMap[s.sessionId] = { sum: 0, n: 0 };
      scoreMap[s.sessionId].sum += s.score;
      scoreMap[s.sessionId].n++;
    });
    state.filteredSessions = state.filteredSessions.map(s => ({
      ...s,
      avgScore: scoreMap[s.sessionId] ? scoreMap[s.sessionId].sum / scoreMap[s.sessionId].n : 0
    }));
  }

  $('sessionsCount').textContent = state.filteredSessions.length;
  $('subsCount').textContent = state.filtered.length;
  $('filterSummary').textContent = `${state.filtered.length} of ${state.rawSubmissions.length} submissions · ${state.filteredSessions.length} sessions`;
  $('sessionsSubtext').textContent = `${state.filteredSessions.length} sessions`;
  $('subsSubtext').textContent = `${state.filtered.length} submissions`;

  renderOverview();
  renderSessionsTable();
  renderSubsTable();
}

function clearFilters() {
  ['fDateFrom','fDateTo','fOrigin','fBrew','fUse','fCupper','fScoreMin','fScoreMax','fDescriptor']
    .forEach(id => $(id).value = '');
  applyFilters();
}

function bindFilters() {
  ['fDateFrom','fDateTo','fScoreMin','fScoreMax','fDescriptor'].forEach(id => {
    $(id).addEventListener('input', applyFilters);
  });
  ['fOrigin','fBrew','fUse','fCupper'].forEach(id => {
    $(id).addEventListener('change', applyFilters);
  });
  $('clearFiltersBtn').addEventListener('click', clearFilters);
}

/* =========================================================
   OVERVIEW STATS + CHARTS
   ========================================================= */
function renderOverview() {
  const subs = state.filtered;
  const sessions = state.filteredSessions;
  const uniqueCoffees = new Set(subs.map(s => s.sessionId + '|' + s.sampleName)).size;

  $('statSessions').textContent = sessions.length;
  $('statCoffees').textContent = uniqueCoffees;
  $('statSubs').textContent = subs.length;

  const avg = subs.length > 0 ? subs.reduce((a,s) => a + s.score, 0) / subs.length : 0;
  $('statAvgScore').textContent = subs.length > 0 ? avg.toFixed(1) : '—';
  $('statAvgSub').textContent = subs.length > 0 ? `across ${subs.length} submissions` : 'no submissions';

  const specialty = subs.filter(s => s.score >= 80).length;
  const specialtyRate = subs.length > 0 ? (specialty / subs.length) * 100 : 0;
  $('statSpecialty').textContent = subs.length > 0 ? specialtyRate.toFixed(0) + '%' : '—';

  renderTrendChart();
  renderDistributionChart();
  renderOriginsChart();
  renderCuppersChart();
  renderDescriptorsChart();
}

function destroyChart(key) {
  if (state.charts[key]) {
    state.charts[key].destroy();
    delete state.charts[key];
  }
}

const COMMON_CHART_OPTS = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: { labels: { font: { family: 'Helvetica Neue, Arial', size: 11 }, color: '#2a2a2a' } },
    tooltip: {
      backgroundColor: '#000',
      titleColor: '#fff',
      bodyColor: '#ffe9d6',
      borderColor: '#FF6C0E',
      borderWidth: 1,
      titleFont: { family: 'Helvetica Neue, Arial', size: 12, weight: '600' },
      bodyFont: { family: 'JetBrains Mono, Courier, monospace', size: 11 }
    }
  }
};

function renderTrendChart() {
  destroyChart('trend');
  const ctx = $('chartTrend');
  if (!ctx) return;
  // Group submissions by month, plot avg score
  const byMonth = {};
  state.filtered.forEach(s => {
    if (!s.sessionDate) return;
    const d = new Date(s.sessionDate);
    const key = d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0');
    if (!byMonth[key]) byMonth[key] = [];
    byMonth[key].push(s.score);
  });
  const labels = Object.keys(byMonth).sort();
  const data = labels.map(k => {
    const arr = byMonth[k];
    return arr.reduce((a,b) => a+b, 0) / arr.length;
  });
  const counts = labels.map(k => byMonth[k].length);
  state.charts.trend = new Chart(ctx, {
    type: 'line',
    data: {
      labels: labels.map(l => {
        const [y, m] = l.split('-');
        return new Date(+y, +m - 1, 1).toLocaleDateString('en-GB', { month: 'short', year: '2-digit' });
      }),
      datasets: [{
        label: 'Avg Score',
        data,
        borderColor: '#FF6C0E',
        backgroundColor: 'rgba(255,108,14,0.1)',
        fill: true,
        tension: 0.3,
        pointBackgroundColor: '#FF6C0E',
        pointRadius: 4,
        pointHoverRadius: 6
      }]
    },
    options: {
      ...COMMON_CHART_OPTS,
      scales: {
        y: { min: 60, max: 95, ticks: { font: { family: 'JetBrains Mono, monospace', size: 10 } }, grid: { color: '#eee' } },
        x: { ticks: { font: { family: 'JetBrains Mono, monospace', size: 10 } }, grid: { display: false } }
      },
      plugins: {
        ...COMMON_CHART_OPTS.plugins,
        tooltip: {
          ...COMMON_CHART_OPTS.plugins.tooltip,
          callbacks: {
            label: (ctx) => `${ctx.parsed.y.toFixed(1)} avg · n=${counts[ctx.dataIndex]}`
          }
        }
      }
    }
  });
}

function renderDistributionChart() {
  destroyChart('distribution');
  const ctx = $('chartDistribution');
  if (!ctx) return;
  // Buckets of 5
  const buckets = [
    { label: '60–64', min: 60, max: 65, n: 0 },
    { label: '65–69', min: 65, max: 70, n: 0 },
    { label: '70–74', min: 70, max: 75, n: 0 },
    { label: '75–79', min: 75, max: 80, n: 0 },
    { label: '80–84', min: 80, max: 85, n: 0 },
    { label: '85–89', min: 85, max: 90, n: 0 },
    { label: '90+',   min: 90, max: 101, n: 0 }
  ];
  state.filtered.forEach(s => {
    for (const b of buckets) {
      if (s.score >= b.min && s.score < b.max) { b.n++; break; }
    }
  });
  state.charts.distribution = new Chart(ctx, {
    type: 'bar',
    data: {
      labels: buckets.map(b => b.label),
      datasets: [{
        label: 'Submissions',
        data: buckets.map(b => b.n),
        backgroundColor: buckets.map(b => b.min >= 80 ? '#FF6C0E' : '#2a2a2a')
      }]
    },
    options: {
      ...COMMON_CHART_OPTS,
      scales: {
        y: { beginAtZero: true, ticks: { precision: 0, font: { family: 'JetBrains Mono, monospace', size: 10 } }, grid: { color: '#eee' } },
        x: { ticks: { font: { family: 'JetBrains Mono, monospace', size: 10 } }, grid: { display: false } }
      },
      plugins: { ...COMMON_CHART_OPTS.plugins, legend: { display: false } }
    }
  });
}

function renderOriginsChart() {
  destroyChart('origins');
  const ctx = $('chartOrigins');
  if (!ctx) return;
  const byOrigin = {};
  state.filtered.forEach(s => {
    if (!s.origin) return;
    if (!byOrigin[s.origin]) byOrigin[s.origin] = [];
    byOrigin[s.origin].push(s.score);
  });
  const entries = Object.entries(byOrigin)
    .map(([k, v]) => ({ origin: k, avg: v.reduce((a,b)=>a+b,0)/v.length, n: v.length }))
    .filter(e => e.n >= 1)
    .sort((a,b) => b.avg - a.avg)
    .slice(0, 10);
  state.charts.origins = new Chart(ctx, {
    type: 'bar',
    data: {
      labels: entries.map(e => e.origin),
      datasets: [{
        label: 'Avg Score',
        data: entries.map(e => e.avg),
        backgroundColor: entries.map(e => e.avg >= 80 ? '#FF6C0E' : '#2a2a2a')
      }]
    },
    options: {
      ...COMMON_CHART_OPTS,
      indexAxis: 'y',
      scales: {
        x: { min: 60, max: 95, ticks: { font: { family: 'JetBrains Mono, monospace', size: 10 } }, grid: { color: '#eee' } },
        y: { ticks: { font: { family: 'Helvetica Neue, Arial', size: 11 } }, grid: { display: false } }
      },
      plugins: {
        ...COMMON_CHART_OPTS.plugins,
        legend: { display: false },
        tooltip: {
          ...COMMON_CHART_OPTS.plugins.tooltip,
          callbacks: {
            label: (ctx) => `${ctx.parsed.x.toFixed(1)} avg · n=${entries[ctx.dataIndex].n}`
          }
        }
      }
    }
  });
}

function renderCuppersChart() {
  destroyChart('cuppers');
  const ctx = $('chartCuppers');
  if (!ctx) return;
  const byCupper = {};
  state.filtered.forEach(s => {
    if (!s.cupperName) return;
    if (!byCupper[s.cupperName]) byCupper[s.cupperName] = 0;
    byCupper[s.cupperName]++;
  });
  const entries = Object.entries(byCupper)
    .sort((a,b) => b[1] - a[1])
    .slice(0, 10);
  state.charts.cuppers = new Chart(ctx, {
    type: 'bar',
    data: {
      labels: entries.map(e => e[0]),
      datasets: [{
        label: 'Submissions',
        data: entries.map(e => e[1]),
        backgroundColor: '#000'
      }]
    },
    options: {
      ...COMMON_CHART_OPTS,
      indexAxis: 'y',
      scales: {
        x: { beginAtZero: true, ticks: { precision: 0, font: { family: 'JetBrains Mono, monospace', size: 10 } }, grid: { color: '#eee' } },
        y: { ticks: { font: { family: 'Helvetica Neue, Arial', size: 11 } }, grid: { display: false } }
      },
      plugins: { ...COMMON_CHART_OPTS.plugins, legend: { display: false } }
    }
  });
}

function renderDescriptorsChart() {
  destroyChart('descriptors');
  const ctx = $('chartDescriptors');
  if (!ctx) return;
  const counts = {};
  state.filtered.forEach(s => {
    parseDescriptors(s.descriptorsRaw).forEach(d => {
      counts[d.name] = (counts[d.name] || 0) + 1;
    });
  });
  const entries = Object.entries(counts).sort((a,b) => b[1] - a[1]).slice(0, 20);
  const palette = {
    purple: '#6b3fa0', white: '#c8b878', yellow: '#e6a93b', red: '#c8362b'
  };
  state.charts.descriptors = new Chart(ctx, {
    type: 'bar',
    data: {
      labels: entries.map(e => e[0]),
      datasets: [{
        label: 'Times Tagged',
        data: entries.map(e => e[1]),
        backgroundColor: entries.map(e => palette[QUAD_MAP[e[0]]] || '#888')
      }]
    },
    options: {
      ...COMMON_CHART_OPTS,
      scales: {
        y: { beginAtZero: true, ticks: { precision: 0, font: { family: 'JetBrains Mono, monospace', size: 10 } }, grid: { color: '#eee' } },
        x: { ticks: { font: { family: 'Helvetica Neue, Arial', size: 10 }, maxRotation: 60, minRotation: 45 }, grid: { display: false } }
      },
      plugins: { ...COMMON_CHART_OPTS.plugins, legend: { display: false } }
    }
  });
}

/* =========================================================
   SESSIONS TABLE
   ========================================================= */
function renderSessionsTable() {
  const tbody = $('sessionsTable');
  const sessions = [...state.filteredSessions].sort((a, b) => {
    const da = new Date(a.date || a.createdAt || 0);
    const db = new Date(b.date || b.createdAt || 0);
    return db - da;   // newest first
  });
  if (sessions.length === 0) {
    tbody.innerHTML = '<tr><td colspan="9" class="empty-state">No sessions match the current filters.</td></tr>';
    return;
  }
  tbody.innerHTML = '';
  sessions.forEach(s => {
    const tr = document.createElement('tr');
    const g = gradeFor(s.avgScore || 0);
    tr.innerHTML = `
      <td class="stamp">${shortDate(s.date)}</td>
      <td class="session-name">${escapeHtml(s.sessionName || '—')}</td>
      <td>${escapeHtml(s.host || '—')}</td>
      <td>${escapeHtml(s.location || '—')}</td>
      <td class="num">${s.coffees || 0}</td>
      <td class="num">${s.cuppers || 0}</td>
      <td class="num">${s.submissions || 0}</td>
      <td class="num scoremark ${g.specialty ? 'specialty' : ''}">${s.avgScore ? s.avgScore.toFixed(1) : '—'}</td>
      <td>
        <button class="row-btn" data-detail-id="${escapeHtml(s.sessionId)}">View</button>
      </td>
    `;
    tbody.appendChild(tr);
  });
  tbody.querySelectorAll('[data-detail-id]').forEach(btn => {
    btn.addEventListener('click', () => openDetail(btn.dataset.detailId));
  });
}

/* =========================================================
   SUBMISSIONS TABLE
   ========================================================= */
function renderSubsTable() {
  const tbody = $('subsTable');
  const subs = [...state.filtered].sort((a, b) => {
    const da = new Date(a.submittedAt || a.sessionDate || 0);
    const db = new Date(b.submittedAt || b.sessionDate || 0);
    return db - da;
  });
  if (subs.length === 0) {
    tbody.innerHTML = '<tr><td colspan="9" class="empty-state">No submissions match the current filters.</td></tr>';
    return;
  }
  tbody.innerHTML = '';
  // Cap to 500 rows for performance; show a note if truncated
  const showSubs = subs.slice(0, 500);
  showSubs.forEach(s => {
    const g = gradeFor(s.score);
    const descs = parseDescriptors(s.descriptorsRaw).slice(0, 6);
    const tr = document.createElement('tr');
    tr.innerHTML = `
      <td class="stamp">${shortDate(s.sessionDate)}</td>
      <td class="coffee-name">${escapeHtml(s.sampleName || '—')}</td>
      <td>${escapeHtml(s.origin || '—')}</td>
      <td>${escapeHtml(s.brew || '—')}</td>
      <td>${escapeHtml(s.use || '—')}</td>
      <td>${escapeHtml(s.cupperName || '—')}</td>
      <td class="num scoremark ${g.specialty ? 'specialty' : ''}">${s.score.toFixed(1)}</td>
      <td><span style="font-size:10px;letter-spacing:0.12em;text-transform:uppercase;color:${g.specialty?'var(--orange)':'var(--ink-50)'};">${g.label}</span></td>
      <td><div class="descriptors-cell">${descs.map(d => `<span class="descriptor-chip q-${QUAD_MAP[d.name] || 'white'}">${escapeHtml(d.name)}</span>`).join('')}</div></td>
    `;
    tbody.appendChild(tr);
  });
  if (subs.length > 500) {
    const tr = document.createElement('tr');
    tr.innerHTML = `<td colspan="9" class="empty-state">Showing first 500 of ${subs.length}. Use filters to narrow down, or export CSV for full list.</td>`;
    tbody.appendChild(tr);
  }
}

/* =========================================================
   SESSION DETAIL
   ========================================================= */
function openDetail(sessionId) {
  const session = state.rawSessions.find(s => s.sessionId === sessionId)
                 || state.filteredSessions.find(s => s.sessionId === sessionId);
  if (!session) { alert('Session not found.'); return; }
  const subs = state.rawSubmissions.filter(s => s.sessionId === sessionId);

  $('detailName').textContent = session.sessionName || 'Untitled';
  const infoParts = [];
  if (session.date) infoParts.push(formatDate(session.date));
  if (session.host) infoParts.push('Hosted by ' + session.host);
  if (session.location) infoParts.push(session.location);
  $('detailInfo').textContent = infoParts.join(' · ');

  // meta cells
  const uniqueCuppers = new Set(subs.map(s => s.cupperName));
  const uniqueCoffees = new Set(subs.map(s => s.sampleName));
  const scores = subs.map(s => s.score);
  const avg = scores.length ? scores.reduce((a,b)=>a+b,0) / scores.length : 0;
  $('detailMeta').innerHTML = `
    <div class="meta-cell"><div class="ml">Coffees</div><div class="mv">${uniqueCoffees.size}</div></div>
    <div class="meta-cell"><div class="ml">Cuppers</div><div class="mv">${uniqueCuppers.size}</div></div>
    <div class="meta-cell"><div class="ml">Submissions</div><div class="mv">${subs.length}</div></div>
    <div class="meta-cell"><div class="ml">Avg Score</div><div class="mv" style="color:${avg >= 80 ? 'var(--orange)' : 'var(--black)'}">${avg ? avg.toFixed(1) : '—'}</div></div>
    <div class="meta-cell"><div class="ml">Closed</div><div class="mv">${session.closedAt ? formatDate(session.closedAt) : '—'}</div></div>
  `;

  // Group by sample
  const bySample = {};
  subs.forEach(s => {
    const key = s.sampleNum + '|' + s.sampleName;
    if (!bySample[key]) bySample[key] = { sampleNum: s.sampleNum, sampleName: s.sampleName, origin: s.origin, brew: s.brew, use: s.use, subs: [] };
    bySample[key].subs.push(s);
  });
  const sorted = Object.values(bySample).sort((a,b) => (parseInt(a.sampleNum) || 0) - (parseInt(b.sampleNum) || 0));

  const container = $('detailCoffees');
  container.innerHTML = '';
  sorted.forEach(group => {
    const subScores = group.subs.map(s => s.score);
    const subAvg = subScores.reduce((a,b)=>a+b,0) / subScores.length;
    const subSpread = subScores.length > 1 ? Math.max(...subScores) - Math.min(...subScores) : 0;
    const g = gradeFor(subAvg);
    const meta = [group.origin, group.brew, group.use].filter(Boolean).join(' · ');

    // Descriptor consensus
    const dcounts = {};
    group.subs.forEach(s => {
      parseDescriptors(s.descriptorsRaw).forEach(d => {
        dcounts[d.name] = (dcounts[d.name] || 0) + 1;
      });
    });
    const topDesc = Object.entries(dcounts).sort((a,b) => b[1] - a[1]).slice(0, 12);

    const row = document.createElement('div');
    row.className = 'coffee-detail-row';
    row.innerHTML = `
      <div class="coffee-detail-head">
        <div class="coffee-idx">${String(parseInt(group.sampleNum) || 0).padStart(2,'0')}</div>
        <div class="coffee-name-block">
          <div class="nm">${escapeHtml(group.sampleName || '—')}</div>
          ${meta ? `<div class="mt">${escapeHtml(meta)}</div>` : ''}
        </div>
        <div class="coffee-summary">
          <div class="avg ${g.specialty ? 'specialty' : ''}">${subAvg.toFixed(1)}</div>
          <div class="meta-text">${g.label} · ±${(subSpread/2).toFixed(1)} · n=${group.subs.length}</div>
        </div>
      </div>
      <div class="coffee-cuppers">
        ${group.subs.map(s => {
          const sg = gradeFor(s.score);
          return `<span class="cupper-chip ${sg.specialty ? 'specialty' : ''}"><span class="cn">${escapeHtml(s.cupperName)}</span><span class="cv">${s.score.toFixed(1)}</span></span>`;
        }).join('')}
      </div>
      ${topDesc.length ? `
        <div class="coffee-descriptors">
          <div class="sec-label">Descriptor Consensus</div>
          <div class="descriptors-cell">
            ${topDesc.map(([n, c]) => `<span class="descriptor-chip q-${QUAD_MAP[n] || 'white'}">${escapeHtml(n)}<span class="ct">×${c}</span></span>`).join('')}
          </div>
        </div>` : ''}
    `;
    container.appendChild(row);
  });

  // hide filters on detail screen
  $('filtersBlock').style.display = 'none';
  // show the detail tab
  document.querySelector('[data-mode="detail"]').style.display = 'inline-flex';
  showMode('detail');
}

/* =========================================================
   MODE SWITCH
   ========================================================= */
function showMode(mode) {
  state.mode = mode;
  document.querySelectorAll('.screen').forEach(s => s.classList.remove('active'));
  $('screen-' + mode).classList.add('active');
  document.querySelectorAll('.mode-tab').forEach(t => t.classList.toggle('active', t.dataset.mode === mode));
  // Filters visible on overview/sessions/submissions
  $('filtersBlock').style.display = (mode === 'detail') ? 'none' : '';
  // Hide detail tab unless we're actively viewing one
  if (mode !== 'detail') {
    document.querySelector('[data-mode="detail"]').style.display = 'none';
  }
}

/* =========================================================
   EXPORT
   ========================================================= */
function escapeCSV(v) {
  if (v === null || v === undefined) return '';
  const s = String(v);
  if (s.includes(',') || s.includes('"') || s.includes('\n')) return '"' + s.replace(/"/g,'""') + '"';
  return s;
}

function exportFilteredCSV() {
  if (state.filtered.length === 0) { alert('No data to export with current filters.'); return; }
  const headers = [
    'Session Date','Session','Sample','Origin','Brew','Use','Cupper',
    'Overall Impression','Final Score','Score Type','Grade','Descriptors','Cupper Notes','Submitted At'
  ];
  const rows = [headers.join(',')];
  state.filtered.forEach(s => {
    rows.push([
      s.sessionDate, s.sessionName, s.sampleName,
      s.origin, s.brew, s.use, s.cupperName,
      s.impression, s.score.toFixed(1), s.scoreType, s.grade,
      s.descriptorsRaw, s.cupperNotes, s.submittedAt
    ].map(escapeCSV).join(','));
  });
  const blob = new Blob(["\uFEFF" + rows.join('\n')], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  const stamp = new Date().toISOString().slice(0,10);
  a.href = url;
  a.download = `48east-cupping-history-${stamp}.csv`;
  document.body.appendChild(a); a.click(); document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

/* =========================================================
   INIT
   ========================================================= */
function bindEvents() {
  document.querySelectorAll('.mode-tab[data-mode]').forEach(t => {
    t.addEventListener('click', () => {
      const m = t.dataset.mode;
      if (m === 'detail') return; // detail entered via View buttons
      showMode(m);
    });
  });
  $('refreshBtn').addEventListener('click', loadAllData);
  $('exportBtn').addEventListener('click', exportFilteredCSV);
  $('detailBackBtn').addEventListener('click', () => {
    $('filtersBlock').style.display = '';
    showMode('sessions');
  });
}

bindEvents();
bindFilters();
loadAllData();